import router from '@/router';

export default {
    async routerLogout() {
        var lms_school = localStorage.getItem('lms_school_custom');

        if (lms_school === 'man1bantul') {
            router.replace('/man1-bantul');
        } else if (lms_school === 'man3bantul') {
            router.replace('/man3bantul');
        } else if (lms_school === 'man4bantul') {
            router.replace('/man4bantul');
        } else if (lms_school === 'man3sleman') {
            router.replace('/man3-sleman');
        } else if (lms_school === 'man1gunungkidul') {
            router.replace('/man1-gunung-kidul');
        } else if (lms_school === 'smakartika') {
            router.replace('/sma-kartika-xxi-makassar');
        } else if (lms_school === 'al-azhar-syifa-budi') {
            router.replace('/alazhar-syifabudi');
        } else {
            router.replace('/login');
        }
    },
};
